
export default {
    name: 'LeeTimeline',
    inheritAttrs: false,
    data() {
        return {
            limitnum: 0,
            totalnum:0
        };
    },
    provide() {
        return {
            timeline:this
        };
    },
    mounted(){
        this.totalnum=this.$slots.default.length
    },
    props: {
        reverse: {
            type: Boolean,
            default: false
        },
        value: {
            type: Number,
            default: 0
        },
        theme: {
            type: Number,
            default: 1
        },
        animate: {
            type: Boolean,
            default: false //默认default
        }
    },
    methods: {
        chuli() {
            this.limitnum = 0
            //this.$emit('input', 0)
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.limitnum = value
            }
        },
        reverse: {
            immediate: true,
            handler(value) {
                if (value) {
                    this.$slots.default = [...this.$slots.default].reverse();
                }
            }
        }
    }
};
